import createApiClient from "./api";

const client = createApiClient();

export const api = {
  // ─── New global endpoints (no orgId) ────────────────────────────────────────

  createActionPlan: (payload) =>
    client.post(`admin/action-plans`, payload).then(({ data }) => data),

  updateActionPlan: ({ actionPlanId, payload }) =>
    client.patch(`admin/action-plans/${actionPlanId}`, payload).then(({ data }) => data),

  deleteActionPlan: ({ actionPlanId }) =>
    client.delete(`admin/action-plans/${actionPlanId}`).then(({ data }) => data),

  getAllActionPlans: ({ search, perPage = 25, currentPage = 1, sortBy, order } = {}) => {
    let url = `admin/action-plans?page=${currentPage}&perPage=${perPage}`;
    if (search) url += `&search=${search}`;
    if (sortBy) url += `&sortBy=${sortBy}`;
    if (order) url += `&order=${order}`;
    return client.get(url).then(({ data }) => data);
  },

  getActionPlanSummary: () =>
    client.get(`admin/action-plans/summary`).then(({ data }) => data),

  // ─── Org-scoped endpoints (kept for backward compatibility) ─────────────────

  getAllActionPlansLearnORGoals: ({ search, perPage, currentPage }) =>
    client
      .get(
        `admin/action-plans/learners?search=${search}&perPage=${perPage}&page=${currentPage}`
      )
      .then(({ data }) => data),

  getAllActionPlansTopCourses: () =>
    client
      .get(`admin/action-plans/courses`)
      .then(({ data }) => data),

  getGoalProgress: ({ orgId }) =>
    client
      .get(`admin/org/${orgId}/action-plans/goal-progress`)
      .then(({ data }) => data),

  getCourses: () => client.get(`admin/courses`).then(({ data }) => data),

  getEmails: (orgId) =>
    client.get(`emails?orgId=${orgId}`).then(({ data }) => data),
};